export default "__VITE_ASSET__ae409073__"